import { SimpleResult } from "../dto";
import { Api, getCompanyId } from "../helpers";
import { IRydeProcess } from "../models";

interface IImportStationsFromBusStationsParams {
  busStationsIds: number[];
  isCreateMissingAreas?: boolean;
}

export class BusStationsApi {
  static async importStationsFromBusStations({
    busStationsIds,
    isCreateMissingAreas = false,
  }: IImportStationsFromBusStationsParams): Promise<
    SimpleResult<IRydeProcess> | undefined
  > {
    const requestUrl = `/api/v1/core/c/${getCompanyId()}/busStations/bulk/import-stations-from-bus-stations`;
    const response = await Api.post<SimpleResult<IRydeProcess> | undefined>(
      requestUrl,
      { payload: { busStationsIds, isCreateMissingAreas } },
    );

    return response?.data;
  }
}
